import {  getKRA_Data } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_KRA_DataThunk = createAsyncThunk(
  "reKyc_KRA_DataThunk",
  async ({ params, token }) => {
    try {
      const response = getKRA_Data(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
